/**
 * Click-to-open tooltips for Logo list (Tri Nature Difference icons).
 */
(function () {
  'use strict';

  function closeAll(container) {
    container.querySelectorAll('[data-logo-tooltip-item].is-active').forEach(function (item) {
      item.classList.remove('is-active');
      var trigger = item.querySelector('[data-logo-tooltip-trigger]');
      var panel = item.querySelector('[data-logo-tooltip-panel]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
      if (panel) {
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function openItem(item) {
    var trigger = item.querySelector('[data-logo-tooltip-trigger]');
    var panel = item.querySelector('[data-logo-tooltip-panel]');
    item.classList.add('is-active');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
    }
  }

  function init(container) {
    if (!container || container.dataset.logoListTooltipsInit === 'true') {
      return;
    }
    container.dataset.logoListTooltipsInit = 'true';

    container.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-logo-tooltip-trigger]');
      if (!trigger || !container.contains(trigger)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      var item = trigger.closest('[data-logo-tooltip-item]');
      if (!item) {
        return;
      }

      var isOpen = item.classList.contains('is-active');
      closeAll(container);
      if (!isOpen) {
        openItem(item);
      }
    });

    document.addEventListener('click', function (event) {
      if (container.contains(event.target)) {
        return;
      }
      closeAll(container);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll(container);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-logo-list-tooltips]').forEach(init);
  }

  window.TriNatureLogoListTooltips = { init: init, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('[data-logo-list-tooltips]');
    if (container) {
      delete container.dataset.logoListTooltipsInit;
      init(container);
    }
  });
})();
